var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "intelligence-v2-chat d-flex flex-column overflow-hidden",
      style: _vm.containerStyle
    },
    [
      !_vm.widget && !_vm.semHeaderDeRota
        ? _c("ConditionalTeleport", {
            attrs: { to: "page-header-actions", routes: _vm.moduleRoutes }
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "d-flex flex-grow-1",
          staticStyle: { "min-height": "0" }
        },
        [
          _vm.usaLayoutFundido
            ? _c("ChatSidebar", {
                staticClass: "flex-shrink-0",
                attrs: {
                  "store-module": _vm.ns,
                  "store-module-historico": _vm.nsDoHistorico,
                  "como-navegacao": _vm.sidebarComoNavegacao,
                  "busca-global-disponivel": _vm.buscaGlobalDisponivel,
                  insights: _vm.sidebarInsights,
                  "insights-estado": _vm.sidebarInsightsEstado,
                  atalhos: _vm.sidebarAtalhos,
                  "cliente-em-foco": _vm.clienteDaLateral,
                  "dados-do-cliente": _vm.sidebarDadosDoCliente,
                  "personalizacao-disponivel":
                    _vm.sidebarPersonalizacaoDisponivel,
                  "modo-personalizacao": _vm.sidebarModoPersonalizacao,
                  "salvando-personalizacao": _vm.sidebarSalvandoPersonalizacao,
                  "itens-personalizaveis-visiveis":
                    _vm.sidebarItensPersonalizaveisVisiveis,
                  "itens-personalizaveis-catalogo":
                    _vm.sidebarItensPersonalizaveisCatalogo,
                  agentes: _vm.agentesVisiveisDoEscritorio,
                  "agente-ativo-id": _vm.agenteAtivoId,
                  "contexto-listagem": _vm.contextoListagem,
                  "carregando-mais": _vm.carregandoMaisConversas,
                  "tem-mais-conversas": _vm.temMaisConversas
                },
                on: {
                  "personalizar-painel": function($event) {
                    return _vm.$emit("personalizar-painel")
                  },
                  "salvar-personalizacao": function($event) {
                    return _vm.$emit("salvar-personalizacao", $event)
                  },
                  "abrir-perfil-cliente": function($event) {
                    return _vm.$emit("abrir-perfil-cliente", $event)
                  },
                  "abrir-tarefas-cliente": function($event) {
                    return _vm.$emit("abrir-tarefas-cliente", $event)
                  },
                  "abrir-contatos-cliente": function($event) {
                    return _vm.$emit("abrir-contatos-cliente", $event)
                  },
                  "abrir-carteira-cliente": function($event) {
                    return _vm.$emit("abrir-carteira-cliente", $event)
                  },
                  "abrir-contratos-cliente": function($event) {
                    return _vm.$emit("abrir-contratos-cliente", $event)
                  },
                  "abrir-transcricoes-cliente": function($event) {
                    return _vm.$emit("abrir-transcricoes-cliente", $event)
                  },
                  "carregar-mais": _vm.carregarMaisConversas,
                  "select-agent": _vm.onEscolherAgenteNaSidebar,
                  "abrir-insight": function($event) {
                    return _vm.$emit("abrir-insight", $event)
                  },
                  "recarregar-insights": function($event) {
                    return _vm.$emit("recarregar-insights")
                  },
                  select: _vm.selecionarConversaEFocar,
                  delete: _vm.deletarConversa,
                  "delete-lote": _vm.deletarConversasEmLote,
                  rename: _vm.renomearConversa,
                  "new-conversation": _vm.novaConversaEFocar,
                  retry: _vm.carregarConversas
                }
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass:
                "no-padding flex-grow-1 d-flex flex-column overflow-hidden intelligence-v2-chat__area",
              class: _vm.classeAreaPrincipal
            },
            [
              _vm.escopoAcimaDasMensagens
                ? _c(
                    "div",
                    {
                      staticClass: "intelligence-v2-chat__escopo",
                      class: {
                        "intelligence-v2-chat__escopo--flutuante":
                          _vm.ancorarEstadoVazio
                      }
                    },
                    [
                      _c("ChatClienteEscopo", {
                        attrs: {
                          cliente: _vm.clienteEscopo,
                          travado: _vm.escopoTravado,
                          agente: _vm.agenteAtualDaConversa,
                          "aviso-de-conversa": _vm.avisoDeConversaTexto,
                          "id-cliente-do-aviso": _vm.idClienteDoAvisoAtual,
                          estreito: !_vm.hasMessages
                        },
                        on: {
                          limpar: function($event) {
                            return _vm.onTrocarEscopo(null)
                          },
                          "abrir-perfil": function($event) {
                            return _vm.$emit("abrir-perfil-cliente", $event)
                          },
                          "trocar-para-cliente": _vm.onTrocarParaClienteDoAviso
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.mostrarChipRun
                ? _c("RunStatusChip", {
                    staticClass: "intelligence-v2-chat__run-chip px-6 pt-2",
                    attrs: {
                      estado: _vm.runAtual.estado,
                      motivo: _vm.runAtual.motivo,
                      "pode-cancelar": _vm.podeCancelarRun,
                      "propostas-abertas": _vm.quantidadePropostasAbertas,
                      "custo-creditos": _vm.custoCreditosDoRun,
                      "pode-tentar-novamente": _vm.podeTentarNovamente,
                      "carregando-tentativa": _vm.tentandoNovamente,
                      "efeitos-conhecidos":
                        _vm.runAtual.efeitos_conhecidos || [],
                      "mostrar-aprovar-todas": _vm.mostrarAprovarTodas,
                      "quantidade-para-aprovar":
                        _vm.propostasAbertasParaLote.length,
                      "aprovando-todas": _vm.aprovandoEmLote
                    },
                    on: {
                      cancelar: _vm.onCancelarRun,
                      "aprovar-todas": _vm.onAprovarTodas,
                      "tentar-de-novo": _vm.onTentarDeNovo
                    }
                  })
                : _vm._e(),
              _vm.mostrarRelatorioDoLote
                ? _c("RelatorioDoLote", {
                    staticClass: "px-4 pt-2",
                    attrs: { linhas: _vm.linhasDoRelatorioDoLote }
                  })
                : _vm._e(),
              _vm.reconectando
                ? _c(
                    "div",
                    {
                      staticClass:
                        "az-text-secondary az-size-12 az-muted px-4 pt-2"
                    },
                    [
                      _vm._v(
                        " Reconectando… (cursor " +
                          _vm._s(_vm.runAtual && _vm.runAtual.seq) +
                          ") "
                      )
                    ]
                  )
                : _vm._e(),
              _c("Messages", {
                ref: "mensagens",
                staticClass: "flex-grow-1",
                attrs: {
                  "store-module": _vm.ns,
                  "largura-limitada": _vm.usaLayoutFundido,
                  "com-indice-de-mensagens": _vm.comIndiceDeMensagens,
                  "com-indice-de-artefatos": _vm.comIndiceDeArtefatos,
                  atalhos: _vm.atalhosDisponiveis,
                  modulos: _vm.ferramentasDoComposer
                },
                on: {
                  "erro-no-trilho": _vm.onErroNoTrilho,
                  feedback: _vm.darFeedback,
                  respond: _vm.responderCartao,
                  "open-service": _vm.onOpenService,
                  "responder-perguntas": _vm.responderPerguntas
                },
                scopedSlots: _vm._u([
                  {
                    key: "antes-das-mensagens",
                    fn: function() {
                      return [
                        _vm.mostrarBoasVindas
                          ? _c("BoasVindasFalada", {
                              staticClass: "mb-4",
                              attrs: {
                                "primeiro-nome": _vm.primeiroNomeDaSessao,
                                concluida: _vm.boasVindasEncerrada,
                                "sem-audio": !_vm.falaDoPrimeiroContatoLigada,
                                "provedor-de-clipe":
                                  _vm.provedorDoClipeDaApresentacao,
                                falante: _vm.falanteDoAvatar,
                                "faixa-de-video": _vm.faixaDeVideoDoAvatar,
                                "faixa-de-audio": _vm.faixaDeAudioDoAvatar
                              },
                              on: {
                                entregue: _vm.aoEntregarBoasVindas,
                                avancar: _vm.avancarDaBoasVindas,
                                fim: _vm.encerrarBoasVindas
                              }
                            })
                          : _vm._e(),
                        _vm.escopoNaConversa
                          ? _c(
                              "div",
                              { staticClass: "intelligence-v2-chat__escopo" },
                              [
                                _c("ChatClienteEscopo", {
                                  attrs: {
                                    cliente: _vm.clienteEscopo,
                                    travado: _vm.escopoTravado,
                                    agente: _vm.agenteAtualDaConversa,
                                    "aviso-de-conversa":
                                      _vm.avisoDeConversaTexto,
                                    "id-cliente-do-aviso":
                                      _vm.idClienteDoAvisoAtual
                                  },
                                  on: {
                                    limpar: function($event) {
                                      return _vm.onTrocarEscopo(null)
                                    },
                                    "abrir-perfil": function($event) {
                                      return _vm.$emit(
                                        "abrir-perfil-cliente",
                                        $event
                                      )
                                    },
                                    "trocar-para-cliente":
                                      _vm.onTrocarParaClienteDoAviso
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "empty",
                    fn: function() {
                      return [
                        !_vm.vozExpandeParaRodape
                          ? _c("EmptyMessages", {
                              ref: "estadoVazio",
                              attrs: {
                                "ancorar-no-topo": _vm.ancorarEstadoVazio,
                                "modulo-em-foco": _vm.ferramentaSelecionada,
                                "ocultar-sugestoes": _vm.ocultarSugestoesNaTela,
                                headline: _vm.personaAtual.headline,
                                acoes: _vm.acoesPorModuloFiltradas,
                                "layout-das-acoes": _vm.layoutDasAcoes,
                                "densidade-das-acoes": _vm.densidadeDaGrade,
                                "aviso-das-acoes": _vm.avisoDasAcoes,
                                "aviso-das-acoes-acao": _vm.avisoDasAcoesAcao,
                                "layout-do-modulo-em-foco":
                                  _vm.layoutDoModuloEmFoco,
                                "modo-de-sugestao": _vm.modoDeSugestao,
                                sugestoes: _vm.sugestoesFixas
                              },
                              on: {
                                "focar-composer": _vm.focarComposer,
                                "limpar-ferramenta": _vm.limparFerramenta,
                                "use-suggestion": _vm.usarSugestao,
                                "usar-comando": _vm.usarComando,
                                "aviso-das-acoes-acao": function($event) {
                                  return _vm.$emit("aviso-das-acoes-acao")
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  _vm.comCartaoDeSuporte
                                    ? {
                                        key: "rodape",
                                        fn: function() {
                                          return [_c("SuporteWhatsappCard")]
                                        },
                                        proxy: true
                                      }
                                    : null,
                                  _vm.composerNoHeroi
                                    ? {
                                        key: "composer",
                                        fn: function() {
                                          return [
                                            _c("SendMessage", {
                                              ref: "composerHeroi",
                                              attrs: {
                                                "store-module": _vm.ns,
                                                ferramentas:
                                                  _vm.ferramentasDoComposer,
                                                "atalhos-de-negocio":
                                                  _vm.atalhosDeNegocioDoCatalogo,
                                                "ferramenta-ativa":
                                                  _vm.ferramentaSelecionada,
                                                "estilo-limpo":
                                                  _vm.estiloLimpoDoComposer,
                                                value: _vm.messageInput,
                                                "pulsar-envio":
                                                  _vm.pulsarEnvioDoComposer,
                                                "duracao-do-pulso-de-envio":
                                                  _vm.duracaoDoPulsoDeEnvio,
                                                loading: _vm.turnoEmVoo,
                                                "model-locked":
                                                  _vm.isModelLocked,
                                                placeholder:
                                                  _vm.placeholderNaTela,
                                                "envio-bloqueado":
                                                  _vm.envioTravado,
                                                "show-agent-select":
                                                  _vm.mostrarSeletorDeEspecialista,
                                                "show-attachments":
                                                  _vm.usaLayoutFundido,
                                                "anexos-liberados":
                                                  _vm.anexosLiberados,
                                                "anexo-de-carteira-liberado":
                                                  _vm.ofereceAnexoDeCarteira,
                                                "focar-ao-montar":
                                                  _vm.sidebarComoNavegacao,
                                                agentes: _vm.agentesDoComposer,
                                                "agente-ativo-id":
                                                  _vm.agenteAtivoIdDoComposer,
                                                "agente-travado":
                                                  _vm.agenteTravado,
                                                "escopo-travado":
                                                  _vm.escopoTravado,
                                                "escopo-de-cliente":
                                                  _vm.escopoDeCliente,
                                                clientes:
                                                  _vm.clientesDoEscritorio,
                                                "cliente-escopo":
                                                  _vm.clienteEscopo,
                                                "agente-ativo":
                                                  _vm.agenteAtualDaConversa,
                                                "id-cliente-anexo":
                                                  _vm.idClienteDoAnexo,
                                                "nome-cliente-anexo":
                                                  _vm.nomeClienteAnexo,
                                                "chave-da-fila-de-anexos":
                                                  _vm.chaveDaFilaDeAnexos,
                                                "superficie-de-voz":
                                                  _vm.superficieDeVozTempoReal,
                                                "delegar-voz":
                                                  _vm.delegarVozTempoReal,
                                                "ler-valor-parcial-de-voz":
                                                  _vm.lerValorParcialDoTurnoVoz,
                                                "id-conversa-de-voz":
                                                  _vm.idConversaDeVoz,
                                                atalhos: _vm.atalhosDisponiveis,
                                                "mostrar-seletor-de-voz": "",
                                                "hide-disclaimer": "",
                                                "sem-dica-de-teclado":
                                                  _vm.semDicaDeTeclado,
                                                large: ""
                                              },
                                              on: {
                                                "escolher-ferramenta":
                                                  _vm.escolherFerramenta,
                                                "limpar-ferramenta":
                                                  _vm.limparFerramenta,
                                                "escopo-change":
                                                  _vm.onTrocarEscopo,
                                                input: _vm.onMessageInput,
                                                send: _vm.onSendMessage,
                                                "enviar-voz": _vm.onEnviarVoz,
                                                abort: _vm.cancelarStream,
                                                "change-agent":
                                                  _vm.onTrocarAgenteDoComposer,
                                                "descer-para-acoes":
                                                  _vm.descerParaAcoes,
                                                "nova-conversa":
                                                  _vm.novaConversa,
                                                "executar-atalho":
                                                  _vm.executarAtalho
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "cabecalho",
                                                    fn: function() {
                                                      return [
                                                        _vm.trilhoQuebrado
                                                          ? _c(
                                                              "ComposerAviso",
                                                              {
                                                                attrs: {
                                                                  tom: "danger",
                                                                  texto:
                                                                    _vm
                                                                      .TEXTO_COMPOSER
                                                                      .trilhoQuebradoFaixa,
                                                                  acao:
                                                                    _vm
                                                                      .TEXTO_COMPOSER
                                                                      .trilhoQuebradoAcao
                                                                },
                                                                on: {
                                                                  acao:
                                                                    _vm.recarregarAPagina
                                                                }
                                                              }
                                                            )
                                                          : _vm.avisoDeCreditos
                                                          ? _c(
                                                              "ComposerAviso",
                                                              {
                                                                attrs: {
                                                                  texto:
                                                                    _vm
                                                                      .avisoDeCreditos
                                                                      .texto,
                                                                  acao:
                                                                    _vm
                                                                      .avisoDeCreditos
                                                                      .acao,
                                                                  fechavel:
                                                                    _vm
                                                                      .avisoDeCreditos
                                                                      .fechavel,
                                                                  "rotulo-de-fechar":
                                                                    _vm.rotuloDeFecharAviso
                                                                },
                                                                on: {
                                                                  acao:
                                                                    _vm.abrirCreditos,
                                                                  fechar:
                                                                    _vm.fecharAvisoDeSaldoBaixo
                                                                }
                                                              }
                                                            )
                                                          : _vm.avisoDaApresentacao
                                                          ? _c(
                                                              "ComposerAviso",
                                                              {
                                                                attrs: {
                                                                  texto:
                                                                    _vm
                                                                      .avisoDaApresentacao
                                                                      .TEXTO,
                                                                  acao:
                                                                    _vm
                                                                      .avisoDaApresentacao
                                                                      .ACAO
                                                                },
                                                                on: {
                                                                  acao:
                                                                    _vm.dispensarApresentacao
                                                                }
                                                              }
                                                            )
                                                          : _c(
                                                              "ComposerAtencao",
                                                              {
                                                                attrs: {
                                                                  quantidade:
                                                                    _vm.sugestoesATriar
                                                                },
                                                                on: {
                                                                  abrir: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$emit(
                                                                      "abrir-sugestoes-a-triar"
                                                                    )
                                                                  }
                                                                }
                                                              }
                                                            )
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                false,
                                                2166241410
                                              )
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    : null
                                ],
                                null,
                                true
                              )
                            })
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ])
              }),
              _c(
                "div",
                {
                  staticClass: "intelligence-v2-chat__rodape",
                  class: _vm.classeTrilhoRodape
                },
                [
                  _vm.conversaComAvatarAtiva
                    ? _c("AvatarDaConversa", {
                        staticClass: "mb-3",
                        attrs: {
                          falando: _vm.avatarFalando,
                          "provedor-de-clipe":
                            _vm.provedorDoClipeDaApresentacao,
                          "faixa-de-video": _vm.faixaDeVideoDoAvatar,
                          "faixa-de-audio": _vm.faixaDeAudioDoAvatar
                        },
                        on: { encerrar: _vm.encerrarConversaComAvatar }
                      })
                    : _vm._e(),
                  _vm.mostrarCartaoDePerfil
                    ? _c("ConfirmarPerfilCard", {
                        staticClass: "mb-3",
                        attrs: {
                          proposta: _vm.propostaDePerfil,
                          salvando: _vm.salvandoPerfil,
                          erro: _vm.erroDoPerfil
                        },
                        on: {
                          confirmar: _vm.confirmarPerfil,
                          dispensar: _vm.dispensarPerfil
                        }
                      })
                    : _vm._e(),
                  !_vm.composerNoHeroi
                    ? _c("SendMessage", {
                        ref: "composerRodape",
                        attrs: {
                          "store-module": _vm.ns,
                          ferramentas: _vm.ferramentasDoComposer,
                          "atalhos-de-negocio": _vm.atalhosDeNegocioDoCatalogo,
                          "ferramenta-ativa": _vm.ferramentaSelecionada,
                          "estilo-limpo": _vm.estiloLimpoDoComposer,
                          value: _vm.messageInput,
                          "pulsar-envio": _vm.pulsarEnvioDoComposer,
                          "duracao-do-pulso-de-envio":
                            _vm.duracaoDoPulsoDeEnvio,
                          loading: _vm.turnoEmVoo,
                          "model-locked": _vm.isModelLocked,
                          placeholder: _vm.placeholderNaTela,
                          "envio-bloqueado": _vm.envioTravado,
                          "show-agent-select": _vm.mostrarSeletorDeEspecialista,
                          "show-attachments": _vm.usaLayoutFundido,
                          "anexos-liberados": _vm.anexosLiberados,
                          "anexo-de-carteira-liberado":
                            _vm.ofereceAnexoDeCarteira,
                          "focar-ao-montar": _vm.sidebarComoNavegacao,
                          agentes: _vm.agentesDoComposer,
                          "agente-ativo-id": _vm.agenteAtivoIdDoComposer,
                          "agente-travado": _vm.agenteTravado,
                          "escopo-travado": _vm.escopoTravado,
                          "escopo-de-cliente": _vm.escopoDeCliente,
                          clientes: _vm.clientesDoEscritorio,
                          "cliente-escopo": _vm.clienteEscopo,
                          "agente-ativo": _vm.agenteAtualDaConversa,
                          "id-cliente-anexo": _vm.idClienteDoAnexo,
                          "nome-cliente-anexo": _vm.nomeClienteAnexo,
                          "chave-da-fila-de-anexos": _vm.chaveDaFilaDeAnexos,
                          "superficie-de-voz": _vm.superficieDeVozTempoReal,
                          "delegar-voz": _vm.delegarVozTempoReal,
                          "ler-valor-parcial-de-voz":
                            _vm.lerValorParcialDoTurnoVoz,
                          "id-conversa-de-voz": _vm.idConversaDeVoz,
                          atalhos: _vm.atalhosDisponiveis,
                          "mostrar-seletor-de-voz": "",
                          "hide-disclaimer": "",
                          "sem-dica-de-teclado": _vm.semDicaDeTeclado
                        },
                        on: {
                          "escolher-ferramenta": _vm.escolherFerramenta,
                          "limpar-ferramenta": _vm.limparFerramenta,
                          "escopo-change": _vm.onTrocarEscopo,
                          input: _vm.onMessageInput,
                          send: _vm.onSendMessage,
                          "enviar-voz": _vm.onEnviarVoz,
                          abort: _vm.cancelarStream,
                          "change-agent": _vm.onTrocarAgenteDoComposer,
                          "descer-para-acoes": _vm.descerParaAcoes,
                          "nova-conversa": _vm.novaConversa,
                          "executar-atalho": _vm.executarAtalho
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "cabecalho",
                              fn: function() {
                                return [
                                  _vm.trilhoQuebrado
                                    ? _c("ComposerAviso", {
                                        attrs: {
                                          tom: "danger",
                                          texto:
                                            _vm.TEXTO_COMPOSER
                                              .trilhoQuebradoFaixa,
                                          acao:
                                            _vm.TEXTO_COMPOSER
                                              .trilhoQuebradoAcao
                                        },
                                        on: { acao: _vm.recarregarAPagina }
                                      })
                                    : _vm.avisoDeCreditos
                                    ? _c("ComposerAviso", {
                                        attrs: {
                                          texto: _vm.avisoDeCreditos.texto,
                                          acao: _vm.avisoDeCreditos.acao,
                                          fechavel:
                                            _vm.avisoDeCreditos.fechavel,
                                          "rotulo-de-fechar":
                                            _vm.rotuloDeFecharAviso
                                        },
                                        on: {
                                          acao: _vm.abrirCreditos,
                                          fechar: _vm.fecharAvisoDeSaldoBaixo
                                        }
                                      })
                                    : _vm.avisoDaApresentacao
                                    ? _c("ComposerAviso", {
                                        attrs: {
                                          texto: _vm.avisoDaApresentacao.TEXTO,
                                          acao: _vm.avisoDaApresentacao.ACAO
                                        },
                                        on: { acao: _vm.dispensarApresentacao }
                                      })
                                    : _vm._e()
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3264872802
                        )
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm.mostraPersonaAviso
                ? _c("PersonaAviso", {
                    staticClass: "flex-shrink-0 px-4 pt-2 pb-2",
                    attrs: { centralizado: "", texto: _vm.textoPersonaAviso }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }